<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.25 14.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5h4.5Zm2-4.25a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h8.5Zm2-4.25a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1 0-1.5h12.5Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Zm2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09Zm2-4a.5.5 0 0 1 .09 1H3.5a.5.5 0 0 1-.09-1h13.09Z"
    />
  </svg>
</template>
